/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  IconButton,

  TextField,
  Typography,
  Autocomplete,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import { useState, useEffect } from "react";
import { getCacheData } from "../../services/CacheService";
import { noFinalizaAnteojoArreglo } from "../../services/ProduccionService";
import DatosGestionAtencionCliente from "./DatosGestionAtencionCliente";
import DatosAnteojoArreglo from "./DatosAnteojoArreglo";
import DatosBandejaActual from "./DatosBandejaActual";
import DatosAreaActual from "./DatosAreaActual";
import DatosAccordion from "./DatosAccordion";
import WaitingDialog from "../../utils/WaitingDialog";

const initialNoFinalizarAnteojoArregloData = {
  bandeja: "",
  idAreaDestino: "",
  observaciones: "",
};
//
// ###########################################################################
//
const NoFinalizarAnteojoArregloDialog = ({
  idGestionAtencion,
  anteojoArreglo,
  idGcAnteojoArreglo,
  bandejaActual,
  onNoFinalizarAnteojoArreglo,
  onClose,
  setMessage,
  setShowMessage,
}) => {
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [noFinalizarAnteojoArregloData, setNoFinalizarAnteojoArregloData] = useState(
    initialNoFinalizarAnteojoArregloData
  );
  const [areas, setAreas] = useState([]);
  const [valueACArea, setvalueACArea] = useState({
    id: "",
    descripcion: "",
  });
  const [inputvalueACArea, setInputvalueACArea] = useState("");
  const [accordionExpanded, setAccordionExpanded] = useState(false);
  const [datosAccordionSummaryCargados, setDatosAccordionSummaryCargados] = useState(false);
  //
  // ################################################################################
  //
  useEffect(() => {
    loadAreas();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (accordionExpanded && !datosAccordionSummaryCargados) {
      setDatosAccordionSummaryCargados(true);
    }
  }, [accordionExpanded]);
  //
  // ################################################################################
  //
  const loadAreas = async () => {
    const response = await getCacheData('area');
    if (response.ok) {
      const _idAreaActual = localStorage.getItem("id_area_deposito");
      const _response = response.data.data.filter(area => area.actividad === "produccion" && area.id !== _idAreaActual);
      setAreas(_response);
    } else {
      setMessage({
        severity: response.messageSeverity,
        messageText: response.messageText,
      });
      setShowMessage(true);
      return;
    }
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setNoFinalizarAnteojoArregloData({
      ...noFinalizarAnteojoArregloData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const getAreaActual = async () => { };
  //
  // ################################################################################
  //
  const getBandejaActual = async () => { };
  //
  // ################################################################################
  //
  const noFinalizarAnteojoArreglo = async () => {

    if (bandejaActual === null) {
      // si el anteojo / arreglo no tiene bandeja asignada
      // la bandeja es obligatoria para finalizar el anteojo / arreglo
      if (!noFinalizarAnteojoArregloData.bandeja) {
        // si no se ha asignado una bandeja
        setMessage({
          severity: "error",
          messageText: "Debes ingresar el número de la bandeja para el " + anteojoArreglo,
        });
        setShowMessage(true);
        return;
      }
    }

    if (!noFinalizarAnteojoArregloData.idAreaDestino) {
      // si no se ha indicado el area de destino
      setMessage({
        severity: "error",
        messageText: "Debes seleccionar el área de destino",
      });
      setShowMessage(true);
      return;
    }

    if (!noFinalizarAnteojoArregloData.observaciones) {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar observaciones para finalizar el Anteojo / Arreglo.",
      });
      setShowMessage(true);
      return;
    }

    let _noFinalizarAnteojoArregloObject = {
      anteojo_arreglo: anteojoArreglo,
      id_gc_anteojo_arreglo: idGcAnteojoArreglo,
      id_area_destino: noFinalizarAnteojoArregloData.idAreaDestino,
      bandeja: bandejaActual === null ? +noFinalizarAnteojoArregloData.bandeja : 0,
      observaciones: noFinalizarAnteojoArregloData.observaciones,
    };

    console.log('---');
    console.log('_noFinalizarAnteojoArregloObject');
    console.log(_noFinalizarAnteojoArregloObject);
    console.log();

    save(_noFinalizarAnteojoArregloObject);
  };
  //
  // ################################################################################
  //
  const save = async (parNoFinalizaAnteojoArreglo) => {
    setIsDoingSomething(true);
    const response = await noFinalizaAnteojoArreglo(parNoFinalizaAnteojoArreglo);
    setIsDoingSomething(false);
    if (response.ok) {
      onNoFinalizarAnteojoArreglo();
    }
    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={handleCloseDialog}
        maxWidth="xl"
        fullWidth={true}
        scroll="body"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Marcar Anteojo / Arreglo como No Finalizado
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Accordion
            sx={{ border: "1px solid LightGrey", mb: 1, p: 0, borderRadius: "5px" }}
            expanded={accordionExpanded}
            onChange={() => {
              setAccordionExpanded(!accordionExpanded);
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <DatosAccordion idGestionAtencion={idGestionAtencion} />
            </AccordionSummary>
            <AccordionDetails>
              {datosAccordionSummaryCargados && (
                <>
                  {idGestionAtencion && (
                    <DatosGestionAtencionCliente idGestionAtencion={idGestionAtencion} />
                  )}

                  {anteojoArreglo && (
                    <>
                      <DatosAnteojoArreglo
                        anteojoArreglo={anteojoArreglo}
                        idGcAnteojoArreglo={idGcAnteojoArreglo}
                      />

                      <DatosAreaActual
                        anteojoArreglo={anteojoArreglo}
                        idGcAnteojoArreglo={idGcAnteojoArreglo}
                        setAreaActual={getAreaActual}
                      />

                      <DatosBandejaActual
                        anteojoArreglo={anteojoArreglo}
                        idGcAnteojoArreglo={idGcAnteojoArreglo}
                        setBandejaActual={getBandejaActual}
                      />
                    </>
                  )}
                </>
              )}
            </AccordionDetails>
          </Accordion>

          <Box
            sx={{
              border: "2px solid steelblue",
              borderRadius: "5px",
              p: 2,
            }}
          >
            <Grid container spacing={1} sx={{ mb: 1 }}>
              {bandejaActual === null && (
                <>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography variant="h6" gutterBottom>
                      Asignar bandeja
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2} lg={2}>
                    <TextField
                      id="bandeja"
                      label="Código de bandeja"
                      size="small"
                      sx={{ width: "100%" }}
                      type="number"
                      inputProps={{
                        autoComplete: "off",
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        style: { textAlign: "left" },
                      }}
                      name="bandeja"
                      value={noFinalizarAnteojoArregloData.bandeja}
                      variant="outlined"
                      onChange={handleChange}
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography variant="h6" gutterBottom>
                  Enviar a
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Autocomplete
                  id="id-area-destino"
                  size="small"
                  width="50%"
                  value={
                    valueACArea && valueACArea.id ? valueACArea : null
                  }
                  onChange={(event, newValue) => {
                    setvalueACArea(newValue);
                    setNoFinalizarAnteojoArregloData({
                      ...noFinalizarAnteojoArregloData,
                      idAreaDestino: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputvalueACArea}
                  onInputChange={(event, newInputValue) => {
                    setInputvalueACArea(newInputValue);
                  }}
                  options={areas}
                  getOptionLabel={(option) => option.descripcion || ""}
                  renderInput={(params) => <TextField {...params} label="Área de Destino" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                // disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={8} lg={8}>
                <TextField
                  id="observaciones"
                  label="Observaciones"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                    style: { textAlign: "left" },
                  }}
                  name="observaciones"
                  value={noFinalizarAnteojoArregloData.observaciones}
                  variant="outlined"
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>

        <DialogActions>
          <Box sx={{ textAlign: "right", p: 1 }}>
            <Button
              sx={{ mr: 1, backgroundColor: "warning" }}
              variant="contained"
              onClick={() => {
                noFinalizarAnteojoArreglo();
              }}
              startIcon={<DoneAllOutlinedIcon />}
            >
              No finalizado
            </Button>
            <Button sx={{ mr: 1 }} variant="outlined" onClick={handleCloseDialog}>
              Cancelar
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default NoFinalizarAnteojoArregloDialog;
